import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import heroImage from "@/assets/hero-cleaning.webp";
import { useT } from "@/i18n";

const Hero = () => {
  const t = useT();
  return <section id="accueil" aria-labelledby="hero-heading" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroImage} 
          alt={t(
            "Service professionnel de nettoyage de bacs à ordures, recyclage et compost à Valleyfield, Beauharnois, Soulanges et Haut-Saint-Laurent par Nettoyage Boudreau",
            "Professional garbage bin, recycling and compost cleaning service in Valleyfield, Beauharnois, Soulanges and Haut-Saint-Laurent by Nettoyage Boudreau"
          )} 
          className="w-full h-full object-cover"
          width="1920"
          height="1080"
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/90 via-foreground/70 to-foreground/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 container-narrow mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-accent/20 backdrop-blur-sm border border-accent/30 rounded-full px-4 py-2 mb-6 animate-fade-up">
            <Sparkles className="w-4 h-4 text-accent" />
            <span className="text-accent font-medium text-sm">{t("Service professionnel et satisfaction assuré !", "Professional service with guaranteed satisfaction!")}</span>
          </div>

          {/* Main Heading */}
          <h1 
            id="hero-heading"
            className="text-4xl lg:text-6xl text-background mb-6 font-sans font-extrabold text-left md:text-6xl"
          >
            {t(
              "Nettoyage de bacs à ordures, recyclage et compost à Valleyfield, Beauharnois, Soulanges et Haut-Saint-Laurent",
              "Garbage bin, recycling and compost cleaning in Valleyfield, Beauharnois, Soulanges and Haut-Saint-Laurent"
            )}
          </h1>

          {/* Subtext */}
          <p className="text-background/90 text-lg md:text-xl mb-8 leading-relaxed animate-fade-up" style={{
          animationDelay: "0.2s"
        }}>
            {t("Service résidentiel, commercial, industriel, scolaire et municipal.", "Residential, commercial, industrial, school and municipal service.")}{" "}
            <span className="font-semibold">Valleyfield · Beauharnois · Soulanges · Haut-Saint-Laurent.</span>
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-up" style={{
          animationDelay: "0.3s"
        }}>
            <Button variant="hero" size="xl" asChild>
              <a href="#soumission">
                {t("Réserver maintenant", "Book now")}
                <ArrowRight className="w-5 h-5" />
              </a>
            </Button>
            <Button variant="heroOutline" size="xl" asChild>
              <a href="#tarification">{t("Voir nos prix", "See our prices")}</a>
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center gap-6 mt-12 animate-fade-up" style={{
          animationDelay: "0.4s"
        }}>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-accent" />
              <span className="text-background/80 text-sm">{t("100% Satisfaction garantie", "100% satisfaction guaranteed")}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-accent" />
              <span className="text-background/80 text-sm">{t("Équipement professionnel", "Professional equipment")}</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-accent" />
              <span className="text-background/80 text-sm">{t("Service local fiable", "Reliable local service")}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-float">
        <div className="w-6 h-10 border-2 border-background/50 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-background/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>;
};
export default Hero;
